import { render, staticRenderFns } from "./SignUpFranchiseStepTwoPending.vue?vue&type=template&id=4416ef5d&scoped=true&"
import script from "./SignUpFranchiseStepTwoPending.vue?vue&type=script&lang=js&"
export * from "./SignUpFranchiseStepTwoPending.vue?vue&type=script&lang=js&"
import style0 from "./SignUpFranchiseStepTwoPending.vue?vue&type=style&index=0&id=4416ef5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4416ef5d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/home/circleci/repo/components/VButton.vue').default})
